"use client";
import { useLanguage } from "@/context/LanguageContext";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Scrollbar, A11y } from "swiper/modules";
import { breakpoints } from "@/utils";
import React from "react";
import { useGlobalContext } from "@/hooks/useGlobalContext";
import { Post } from "@/constants/types";
import DomaineCard from "../activity/DomaineCard";
import Link from "next/link";

const WhatWedoSection = () => {
  const { t } = useLanguage();
  const { domaines } = useGlobalContext();
  return (
    domaines &&
    domaines?.length > 0 && (
      <div className="tp-mission-2__area tp-mission-2__space p-relative fix z-index grey-bg">
        <div className="tp-mission-2__shape">
          <img src="/assets/img/mission/mission-shape-1.png" alt="" />
        </div>
        <div className="tp-mission-2__plr">
          <div className="container-fluid g-0">
            <div className="row">
              <div className="col-xl-5 col-lg-7 col-md-7">
                <div className="tp-mission-2__left-box">
                  <div className="tp-mission-2__section-box pb-10">
                    <span className="tp-section-subtitle-2">
                      {t("WhatWeDo")}
                    </span>
                    <h4 className="tp-section-title" dangerouslySetInnerHTML={{
                      __html:t("WhatWeDoTitle")
                    }}>
                     
                    </h4>
                  </div>
                  <div className="tp-mission-2__left-text">
                    <p dangerouslySetInnerHTML={{
                      __html:t("WhatWeDoDesc")
                    }}>
                     
                    </p>
                    <Link className="tp-btn" href="/make-donation">
                      {t("DonateNow")}
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-7 col-lg-5 col-md-5">
                <div className="tp-mission-2__wrapper">
                  <div className="swiper-container tp-mission-2__active">
                    <Swiper
                      className="swiper-wrapper"
                      spaceBetween={20}
                      effect="cards"
                      breakpoints={breakpoints}
                      modules={[Autoplay, Pagination, Scrollbar, A11y]}
                      loop={true}
                      autoplay={{ delay: 3000 }} // Auto-slide every 3 seconds
                      pagination={{ clickable: true }}
                      speed={2000} // Enable pagination dots
                    >
                      {domaines.map((domaine: Post, index: number) => (
                        <SwiperSlide key={index}>
                          <DomaineCard domaine={domaine} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default WhatWedoSection;
